module.exports = __webpack_public_path__ + "static/media/cover5.a5fb649c.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/cover5.png
// module id = 558
// module chunks = 0